function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { colors } from '@guryou/colors';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import '../assets/inputFields.css';
const ColorBox = ({
  color,
  ...rest
}) => {
  if (color) {
    rest.defaultValue = color.startsWith('#') ? color : `#${color}`;
  }
  return /*#__PURE__*/React.createElement(TextField, _extends({
    margin: "normal"
  }, rest, {
    type: "color"
  }));
};
ColorBox.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string
};
ColorBox.defaultProps = {
  color: colors.mandy
};
export default ColorBox;